module.exports = __webpack_public_path__ + "media/images/app/thank-you-page/master-card-190a1378bb7d66dd18c5a93b32227332.webp";